import api from './client';

export const sendTip = async (liveId, amount, message = '', clientRef = undefined) => {
  const res = await api.post(`/lives/${liveId}/tips`, { amount, message, client_ref: clientRef });
  return res.data;
};

export const listTips = async (liveId, since = null) => {
  const params = since ? { since } : {};
  const res = await api.get(`/lives/${liveId}/tips`, { params });
  return res.data;
};
